// Re-export from apiUrl for backwards compatibility
export { getBackendUrl, getBackendUrl as getApiUrl, API_BASE_URL as API_URL } from '@/utils/apiUrl';

// Helper function to build API URLs
export const apiUrl = (path) => {
  const { getBackendUrl } = require('@/utils/apiUrl');
  const baseUrl = getBackendUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};
